import { useMarketplaceConfig } from '../queries/marketplace';

const useMarketplaceCurrency = () => {
  const { data: marketplaceConfig } = useMarketplaceConfig();
  return marketplaceConfig?.marketplaceConfig.currency ?? 'EUR';
};

export default useMarketplaceCurrency;
